import * as Mutations from "./mutations";
import { Confirmation } from "@/store/modules/confirm/Confirmation";

export const ModalModule = {

    state: {
        modal: null,
        closeModalCallback: null,
        options: null,
        submitClick: false
    },

    mutations: {
        [Mutations.SET_MODAL](state, payload) {
            state.modal = payload;
        },

        [Mutations.REMOVE_MODAL](state) {
            state.modal = null;
        },

        [Mutations.SET_ON_CLOSE_CALLBACK](state, callback = null) {
            state.closeModalCallback = callback;
        },

        [Mutations.REMOVE_ON_CLOSE_CALLBACK](state) {
            state.closeModalCallback = null;
        },

        [Mutations.SET_OPTIONS](state, options = null) {
            state.options = options;
        },

        [Mutations.REMOVE_OPTIONS](state) {
            state.options = null;
        },

        [Mutations.TOGGLE_SUBMIT_CLICK](state, value) {
            state.submitClick = value;
        }
    },

    actions: {
        openModal(context, { modalName, options, callback }) {
            window.Beacon("destroy");
            setTimeout(() => {
                context.commit(Mutations.SET_MODAL, modalName);
                context.commit(Mutations.SET_OPTIONS, options);
                context.commit(Mutations.SET_ON_CLOSE_CALLBACK, callback);
            });
            document.body.classList.add("stop-scrolling");
        },

        closeModal(
            { state, getters, commit, dispatch },
            { submitted, dangerClose } = { submitted: false }
        ) {
            if (state.options && state.options.confirmOnClose && !dangerClose) {
                dispatch(
                    "openConfirmDialog",
                    new Confirmation(
                        () => {
                            window.Beacon("init", process.env.HELP_SCOUT_ID);
                            if (getters.closeModalCallback) {
                                getters.closeModalCallback({ submitted });
                                commit(Mutations.REMOVE_ON_CLOSE_CALLBACK);
                            }
                            commit(Mutations.REMOVE_MODAL);
                            commit(Mutations.REMOVE_OPTIONS);
                            document.body.classList.remove("stop-scrolling");
                            dispatch("cancelPaymentFlow");
                        },
                        "Are you sure you want to close this modal?",
                        () => {}
                    )
                );
            } else {
                window.Beacon("init", process.env.HELP_SCOUT_ID);
                if (getters.closeModalCallback) {
                    getters.closeModalCallback({ submitted });
                    commit(Mutations.REMOVE_ON_CLOSE_CALLBACK);
                }
                commit(Mutations.REMOVE_MODAL);
                commit(Mutations.REMOVE_OPTIONS);
                document.body.classList.remove("stop-scrolling");
            }
        },

        toggleSubmitClick(context, value) {
            context.commit(Mutations.TOGGLE_SUBMIT_CLICK, value);
        }
    },

    getters: {
        currentModal: state => state.modal
            ? () => import(`@/components/modals/${state.modal}`)
            : null,

        closeModalCallback: (state) => state.closeModalCallback,

        options: (state) => state.options,

        submitClick: state => state.submitClick
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/modal/modal.module.js